import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Faq from "./pages/Faq";
import ContactUs from "./pages/ContactUs";
import About from "./pages/About";
import Semisters from "./pages/Semisters";
import TermsCondition from "./pages/TermsCondition";
import PageNotFound from "./pages/PageNotFound";
import AllPrograms from "./pages/AllPrograms.jsx";
import ProgramDesc from "./pages/ProgramDesc.jsx";
import Nots from "./pages/Notes.jsx";
import Aos from "aos";
import { useEffect } from "react";
import ProgramNotes from "./pages/ProgramNotes.jsx";

function App() {
  useEffect(() => {
    Aos.init({
      disable: "false",
      duration: 2000,
      once: true,
    });
  }, []);
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/about" element={<About />} />
        <Route path="/semisters/:slug" element={<Semisters />} />
        <Route path="/notes/:slug" element={<Nots />} />
        <Route path="/terms" element={<TermsCondition />} />
        <Route path="/programs/:slug" element={<AllPrograms />} />
        <Route path="/program-notes" element={<ProgramNotes />} />
        <Route path="/programe-description/:slug" element={<ProgramDesc />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}

export default App;
